import { Box, Typography } from "@mui/material";

// svg
import {ReactComponent as IconAlert} from "../../assets/svg/alert-circle.svg";

export const ViewOnlyMsg = () => {
  return (
    <Box
      sx={{
        display: "flex",
        p: "8px 16px 0 16px",
        gap: "8px",
        alignItems: "center",
      }}
    >
      <IconAlert stroke="#d9931b" width={"16px"} height={"16px"} />
      <Typography color="#d9931b" fontSize={"12px"}>
        View only access. Actions are disabled.
      </Typography>
    </Box>
  );
};
